const s3Staging = 'https://xdev-api.s3-ap-southeast-1.amazonaws.com';
const s3Xsta = 'https://xsta-s3.3ona.co';
const s3Production = 'https://xpro-s3.crypto.com';
const envMap = {
  production: { text: 'production', s3: s3Production },
  'dprd-internal': { text: 'production', s3: s3Production },
  development: { text: 'dstg', s3: s3Production },
  xdev: { text: 'dstg', s3: s3Staging },
  xsta: { text: 'dpre', s3: s3Xsta },
};

export const isNonRealProdApp = import.meta.env.VITE_APP_ENV !== 'production';
export const isPreApp = import.meta.env.VITE_APP_ENV === 'dprd-internal';
export const isProdApp =
  import.meta.env.VITE_APP_ENV === 'production' || isPreApp;
export const isDevMode = import.meta.env.DEV === true;
export const isTestMode = import.meta.env.VITE_APP_TEST === 'true'; // to be string after vite parsed

export const isGTMEnv =
  isProdApp || import.meta.env.VITE_GTM_ENABLED === 'true';

export const envText = ['dstg', 'ddev', 'dpre'].includes(
  import.meta.env.VITE_APP_ENV,
)
  ? import.meta.env.VITE_APP_ENV
  : (envMap[import.meta.env.VITE_APP_ENV as keyof typeof envMap]?.text as
      | string
      | undefined) || 'dstg'; // Default to 'dstg' in test/undefined environments

export const STATIC_DOMAIN_PROD = 'https://static2.crypto.com/exchange';
export const STATIC_DOMAIN = isProdApp
  ? STATIC_DOMAIN_PROD
  : isDevMode
    ? '/static-oex'
    : 'https://asta-static-cms.3ona.co/exchange';
export const FCM_STATIC_DOMAIN = isProdApp
  ? STATIC_DOMAIN_PROD
  : isDevMode
    ? '/static-fcm'
    : 'https://asta-static-cms.3ona.co/fcm';
export const CoinBaseURL = `${STATIC_DOMAIN}/token-icons`;
export const ACCREDITED_INVESTOR_DOMAIN = isProdApp
  ? 'http://prod-alfred-fe.crypto.com'
  : 'https://uat-alfred-fe.3ona.co';
